import axios from 'axios';

export type VerificationStatus =
  | 'NotStarted'
  | 'Pending'
  | 'Success'
  | 'Failed'
  | 'TemporaryFailure';

export interface UsuarioMailStatus {
  id: number | null;
  email: string | null;
  displayName: string | null;
  verificationStatus: VerificationStatus;
  puedeEnviar: boolean;
  verificationRequestedAt: string | null;
  verifiedAt: string | null;
}

/** Config local; null si 404 (nunca configuró). */
export async function fetchUsuarioMail(): Promise<UsuarioMailStatus | null> {
  try {
    const { data } = await axios.get<UsuarioMailStatus>('api/usuario/me/mail');
    return data;
  } catch (e: unknown) {
    if (axios.isAxiosError(e) && e.response?.status === 404) return null;
    throw e;
  }
}

/** Sincroniza estado con SES (requiere config previa). */
export async function refreshUsuarioMailStatus(): Promise<UsuarioMailStatus> {
  const { data } = await axios.get<UsuarioMailStatus>('api/usuario/me/mail/refresh');
  return data;
}

/** Envía verificación SES con el email del usuario. */
export async function validarUsuarioMail(
  email: string,
  displayName?: string,
): Promise<UsuarioMailStatus> {
  const { data } = await axios.post<UsuarioMailStatus>('api/usuario/me/mail/validar', {
    email,
    displayName,
  });
  return data;
}

export function usuarioMailErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data;
    if (typeof data === 'string' && data.trim()) return data;
    if (data && typeof data === 'object' && 'detail' in data) {
      const detail = (data as { detail?: unknown }).detail;
      if (typeof detail === 'string' && detail.trim()) return detail;
    }
    if (error.message) return error.message;
  }
  if (error instanceof Error && error.message) return error.message;
  return 'No se pudo completar la operación de mail.';
}
